import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FaFacebook } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import logowhite from '../Images/Logo-white.png';
import gsap from 'gsap';
import { Link as ScrollLink } from 'react-scroll';

function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [sticky, setSticky] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 10) {
                setSticky(false);
            } else if (currentScrollY < lastScrollY || currentScrollY <= 10) {
                setSticky(true);
            }

            setLastScrollY(currentScrollY);
            setScrolled(currentScrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    useEffect(() => {
        const disableScroll = (event) => {
            event.preventDefault();
        };

        if (window.innerWidth > 991.99) {
            window.addEventListener('scroll', disableScroll, { passive: false });

            const NavbarAnimation = gsap.timeline({
                onComplete: () => {
                    window.removeEventListener('scroll', disableScroll);
                }
            });

            NavbarAnimation
                .fromTo(".web-logo", { y: -30, opacity: 0 }, { y: 0, opacity: 1 })
                .fromTo(".header-link", { y: -30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.3 }, ">")
                .fromTo(".navbar-icons", { y: -30, opacity: 0 }, { y: 0, opacity: 1, stagger: -0.3 }, "-=1.5");

            return () => {
                window.removeEventListener('scroll', disableScroll);
                NavbarAnimation.kill();
            };
        }
    }, []);

    return (
        <Navbar
            expand="lg" 
            className={`bg-white position-fixed ${scrolled ? 'shadow-b' : ''} ${sticky ? 'sticky-header' : 'hide-header'}`}
            style={{ zIndex: 9999 }}
        >
            <Container>
                <Navbar.Brand href="/" className='web-logo'>
                    {/* <h2 className='text-center fw-bold fs-4 text-b'>Dashlani<br />Technology</h2> */}
                    <img src={logowhite} alt="logo" fluid width={160} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarScroll" className='overflow-hidden' />
                <Navbar.Collapse id="navbarScroll">
                    <Nav className="mx-auto py-3 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
                        <Nav.Link >
                            <ScrollLink to="Home" smooth={true} duration={1000} className='fw-semibold mx-2 fs-6 header-link position-relative'>Home</ScrollLink>
                        </Nav.Link>
                        <Nav.Link >
                            <ScrollLink to="Service" smooth={true} duration={1000} className='fw-semibold mx-2 fs-6 header-link position-relative'>Our Services</ScrollLink>
                        </Nav.Link>
                        <Nav.Link >
                            <ScrollLink to="Product" smooth={true} duration={1000} className='fw-semibold mx-2 fs-6 header-link position-relative'>Products</ScrollLink>
                        </Nav.Link>
                        <Nav.Link >
                            <ScrollLink to="About" smooth={true} duration={1000} className='fw-semibold mx-2 fs-6 header-link position-relative'>About Us</ScrollLink>
                        </Nav.Link>
                        <Nav.Link >
                            <ScrollLink to="Contact" smooth={true} duration={1000} className='fw-semibold mx-2 fs-6 header-link position-relative'>Contact Us</ScrollLink>
                        </Nav.Link>
                    </Nav>
                    <Nav className="justify-content-end">
                        <Nav.Item className="d-flex">
                            <Nav.Link className='ms-lg-0 navbar-icons ms-3' href="https://www.linkedin.com/company/dashlani-technology-pvt-ltd/posts/?feedView=all"><FaLinkedinIn className='fs-5 linkdin' /></Nav.Link>
                            <Nav.Link className='ms-lg-0 navbar-icons ms-3' href="https://www.facebook.com/profile.php?id=61564509575076"><FaFacebook className='fs-5 facebook' /></Nav.Link>
                            <Nav.Link className='ms-lg-0 navbar-icons ms-3' href="https://www.instagram.com/dashlani.technology.pvt.ltd/?hl=en"><AiFillInstagram className='fs-5 instagram text-b-secondary rounded' /></Nav.Link>
                            <Nav.Link className='ms-lg-0 navbar-icons ms-3' href="https://api.whatsapp.com/send?phone=918849319706"><FaWhatsapp className='fs-5 whatsapp' /></Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
